import { FC, useEffect, useState } from 'react';
import cn from 'bem-cn';

import { Button, Icon, Modal } from '../../UI';
import { AuthModalProps } from './AuthModal.types';

import './AuthModal.scss';

const b = cn('auth-modal');

export const AuthModal: FC<AuthModalProps> = ({ isOpen, onClose, retpath, onCloseFunction }) => {
    const [passportLink, setPassportLink] = useState<string>('https://passport.yandex.ru/auth/welcome?mode=auth');

    useEffect(() => {
        const finalRetpath = encodeURIComponent(retpath || window.location.href);

        if (process.env.NODE_ENV === 'development') {
            setPassportLink(`https://passport-test.yandex.ru/auth/welcome?mode=auth&retpath=${finalRetpath}`);

            return;
        }

        setPassportLink(`https://passport.yandex.ru/auth/welcome?mode=auth&retpath=${finalRetpath}`);
    }, [retpath]);

    const handleCloseModal = () => {
        onClose();
        onCloseFunction?.();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleCloseModal}>
            <div className={b()}>
                <div className={b('icon')}>
                    <Icon name="person" size={32} fillColor="var(--accent-color)" />
                </div>
                <h2 className={b('title')}>Для этого войдите</h2>
                <p className={b('subtitle')}>С Яндекс ID это займёт пару секунд</p>
                <a href={passportLink}>
                    <Button>Войти</Button>
                </a>
            </div>
        </Modal>
    );
};
